import { render } from "./projects.vue?vue&type=template&id=6bf62404&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"

import "./projects.vue?vue&type=style&index=0&id=6bf62404&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/GitHub/cristhianVeAl_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf62404"]])

export default __exports__